import {HandlerList} from "../../../infrastructure/handlers/handler-list";
import {H2hWidgetFetchHandler} from "./h2h-widget.fetch-handler";
import {H2hWidgetAnalyticsDisplayHandler} from "./h2h-widget.analytics-display.handler";
import {TimingHandler} from "../../../infrastructure/handlers/timing-handler";
import {H2hWidgetTabChangeHandler} from "./h2h-widget.tab-change.handler";
import {TabClickEventHandler} from "../../../core/handlers/tab.click-event.handler";
import {PopulateDataHandler} from "../../../infrastructure/handlers/populate-data-handler";
import {
  SeeAllButtonClickAnalyticsEventHandler
} from "../../../core/handlers/see-all-button-click.analytics-event.handler";

export class H2hWidgetHandlers extends HandlerList {
  static injectables = [
    H2hWidgetFetchHandler,
    H2hWidgetTabChangeHandler,
    H2hWidgetAnalyticsDisplayHandler,
    TabClickEventHandler,
    SeeAllButtonClickAnalyticsEventHandler,
    TimingHandler,
    PopulateDataHandler
  ];

  constructor(
    h2hWidgetFetchHandler: H2hWidgetFetchHandler,
    h2hWidgetTabChangeHandler: H2hWidgetTabChangeHandler,
    h2hWidgetAnalyticsDisplayHandler: H2hWidgetAnalyticsDisplayHandler,
    tabClickEventHandler: TabClickEventHandler,
    seeAllButtonClickAnalyticsEventHandler: SeeAllButtonClickAnalyticsEventHandler,
    timingHandler: TimingHandler,
    populateDataHandler: PopulateDataHandler,
  ) {
    super();

    [
      h2hWidgetFetchHandler,
      h2hWidgetTabChangeHandler,
      h2hWidgetAnalyticsDisplayHandler,
      tabClickEventHandler,
      seeAllButtonClickAnalyticsEventHandler,
      timingHandler,
      populateDataHandler
    ].forEach(handler => this.add(handler));
  }
}
